import FormDescription from "../../../../../../packages/design-system/src/FormDescription";
import * as React from 'react';
export default {
  FormDescription,
  React
};